import React__default from 'react';
import { b as TouchLinkContent, c as TouchLinkIcon } from './TouchLink.styles-BK5TOa7j.js';
import { b as angleInlineEnd } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-sBnDaVj5-23EprBeB.js';

const TouchLinkBody = ({
  children
}) => /*#__PURE__*/React__default.createElement(TouchLinkContent, null, children, /*#__PURE__*/React__default.createElement(TouchLinkIcon, {
  type: angleInlineEnd,
  size: "lg"
}));

export { TouchLinkBody as T };
//# sourceMappingURL=TouchLinkBody-ChvT5l_a.js.map
